import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Section, UserContent } from 'listing/layout';
import { SectionHeading } from 'core/styles';
import { stripTags } from 'core/utils';

import { YoutubeContainer } from './YoutubeContainer';
import { Divider } from 'listing/layout';
import { Title } from 'listing/layout';

const AboutContainer = ({
	description,
	heading,
	valueProposition,
	clean,
	youtubeURL
}) => (
	<Fragment>
		<Section id="about" clean={clean}>
			<Title>Product Details</Title>
			<UserContent marginBottom>
				{heading && (
					<SectionHeading>{stripTags(heading)}</SectionHeading>
				)}
				{description && (<p>{ stripTags(description) }</p>)}
				{valueProposition && ((valueProposition).startsWith("<ul>") ? (
					<div dangerouslySetInnerHTML={{ __html: valueProposition }}/>
				) : <div>
					<ul>
						{valueProposition.split(" , ").map((item, idx) => (
							<li key={idx}>{item}</li>
						))}
					</ul>
				</div>)
				}
				{youtubeURL && <YoutubeContainer youtubeURL={youtubeURL} />}
			</UserContent>
			<Divider />
		</Section>
	</Fragment>
);

AboutContainer.propTypes = {
	description: PropTypes.string,
	valueProposition: PropTypes.string,
	heading: PropTypes.string,
	clean: PropTypes.bool,
	youtubeURL: PropTypes.string,
};

AboutContainer.defaultProps = {};

export default AboutContainer;
